import React, { useContext, useState } from 'react';
import CanvasContext from '../../../context/CanvasContext';
import styles from './styles/LinkSituation.module.css';

const LinkSituation = ({ nextSituation }) => {
    const { situations, updateChoiceAndEdge, selectedChoice } = useContext(CanvasContext);
    const [searchTerm, setSearchTerm] = useState('');

    
    const isNextSituationUndefined = !nextSituation || !situations.find(situation => situation._id === nextSituation._id);

    
    const handleSituationClick = async (situationId) => {
        
        if (!selectedChoice || !selectedChoice._id) {
            console.error("Cannot link situation: No choice selected.");
            return;
        }
        
        if (nextSituation && situationId === (nextSituation._id || nextSituation)) {
            console.log("Situation already linked.");
            return; 
        }

        try {
            console.log(`Attempting to link choice ${selectedChoice._id} to situation ${situationId}`);
            const result = await updateChoiceAndEdge(selectedChoice._id, { nextSituation: situationId });

            if (result && result.updatedChoice) {
                 console.log(`Successfully updated choice ${result.updatedChoice._id}. New nextSituation ID: ${result.updatedChoice.nextSituation?._id || result.updatedChoice.nextSituation}`);
            }
            if (result && result.updatedEdge) {
                console.log(`Corresponding edge ${result.updatedEdge.id} target updated to: ${result.updatedEdge.target}`);
            }


        } catch (error) {
            console.error(`Error linking choice ${selectedChoice?._id} to situation ${situationId}:`, error);
            
        }
    };

    const filteredSituations = situations
        .filter(situation => situation && situation.title.toLowerCase().includes(searchTerm.toLowerCase())); 

        return (
            <div className={styles.linkSituationContainer}>
                {/* Ensure selectedChoice exists before accessing title */}
                <h2 className={styles.selectedChoiceTitle}>
                    {selectedChoice?.title || 'No Choice Selected'}
                </h2>
        
                <h3 className={styles.situationListTitle}>Link to Situation:</h3>
        
                {/* Search bar */}
                <div className={styles.searchContainer}> {/* Optional: Wrap for potential icon */}
                    <input
                        type="search" 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search situations..."
                        className={styles.searchInput}
                        aria-label="Search situations to link" 
                    />
                    {/* You could add a search icon here if desired */}
                </div>
        
        
                {/* Warning message - placed prominently */}
                {isNextSituationUndefined && (
                    <p className={styles.warningText}>
                        ⚠️ This choice is currently linked to an unknown or deleted situation. Please select a new one.
                    </p>
                )}
        
                <div className={styles.listWrapper}>
                    {filteredSituations.length > 0 ? (
                         <ul className={styles.situationList}>
                            {filteredSituations.map((situation, index) => ( 
                                <li
                                    
                                    key={situation?._id ?? `situation-${index}`}
                                    className={`${styles.situationItem} ${
                                        situation?._id === nextSituation?._id
                                            ? styles.highlightedSituation
                                            : ''
                                    }`}
                                    onClick={() => handleSituationClick(situation?._id)}
                                    
                                    
                                    
                                    role="button" 
                                    aria-pressed={situation?._id === nextSituation?._id} 
                                >
                                    {/* Title within the list item - this needs wrapping too */}
                                    <span className={styles.situationItemTitle}>
                                        {situation?.title || 'Untitled Situation'}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className={styles.noResultsText}>
                            {searchTerm ? 'No situations match your search.' : 'No situations available.'}
                        </p>
                    )}
        
                </div>
            </div>
        );
};

export default LinkSituation;
